import { last } from "lodash";
import util from "util";
import Term from "../Term";
import { TYPE_ARRAY } from "../constants";

class GroupedTerms {
  constructor(key, term) {
    this.key = key;
    this.terms = term ? [term] : [];
  }

  push(item, empty) {
    if (item instanceof GroupedTerms) {
      this.push([item], empty);
    } else if (Array.isArray(item)) {
      item.forEach((gt) => {
        this.terms = this.terms.concat(gt.terms);
        if (empty) gt.terms = [];
      });
    } else {
      throw new Error("strange item pushed to GroupedTerms " + item);
    }
  }
}

/**
 * this clusters nodes bby a characteristic, returnedd
 * by the test fn. Unlike lodash groupBy it works
 * in series, not in aggregate; i.e., it compares the outyput
 * to the output of the last node in a series not the
 * whole collection. ;
 * @param series
 * @param test
 */
const groupBy = (series, test) => {
  if (!Array.isArray(series)) {
    throw new Error(
      "groupBy requires arrays or terms that have array values only"
    );
  }

  /*
   iterate through the values, returning arrays of sets
    */
  return series.reduce((memo, term) => {
    const lastTerm = last(memo);
    const key = test(term, memo, lastTerm);
    if (!memo.length) {
      return [new GroupedTerms(key, term)];
    }
    // If current term is a new "turn", even if same speaker, create new GroupedTerms
    if (term.meta === "turn") {
      memo.push(new GroupedTerms(key, term));
    }
    // If last and current speaker for term is the same, append to last term
    else if (lastTerm.key === key) {
      lastTerm.terms.push(term);
    } else {
      memo.push(new GroupedTerms(key, term));
    }
    return memo;
  }, []);
};

export default groupBy;
